function Item ({ url, image, name, category, pageid, content, key }) {

const media = JSON.parse(content);

  return (
    <div class="col pb-2 pb-sm-3">
      <div class="card-hover box-shadow position-relative bg-secondary rounded-1 p-3 mb-4">
        <a class="swiper-wrapper" href={'/productdetails?id=' + url}>
          <img src={media.media[0].url || "https://dealerbi.com/assets/images/features/market-dashboard.jpg"} class="card-img-top" alt="Card Image"/>
        </a>
        <div class="d-flex mb-1 pt-2">
            <h3 class="h6 mb-0"><a href={'/productdetails?id=' + url}>{name}</a></h3>
        </div>
        <div class="d-flex align-items-center">           
          <div class="d-flex">
              <span class="me-2">{category}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Item
